<script lang="ts">
    import { notificationsStore } from '../stores'
    import { fade } from 'svelte/transition'
</script>

{#each $notificationsStore as notification, i (notification.id)}
    <div class="notification-message notification-message-{notification.type} notification-message-{i}" out:fade>
        <span on:click={() => notificationsStore.remove(notification.id)} class="close"></span>
        
        <h3>{notification.title}</h3>
        
        {#if notification.imagePath}
            <div class="notification-image">
                <img src="{notification.imagePath}" alt="" draggable="false">
            </div>
        {/if}
        
        <div class="notification-details">
            {#if notification.message}
                <p class="notification-name">{notification.message}</p>
            {/if}
            {#if notification.message2}
                <p class="notification-variant">{notification.message2}</p>
            {/if}
        </div>
    </div>
{/each}